import React from 'react';

export const LogoutIcon = ({stroke = 'var(--primary)', size = 18, ...props}) => (
  <svg
    {...props}
    height={size}
    width={size}
    viewBox="0 0 20 18"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M107,688l-4-4m0,0,4-4m-4,4h14m-5,4v1a3,3,0,0,1-3,3h-7a3,3,0,0,1-3-3V679a3,3,0,0,1,3-3h7a3,3,0,0,1,3,3v1"
          transform="translate(-98 -675)" fill="none" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"
          strokeWidth="2"/>
  </svg>
);

export default LogoutIcon;
